// *Component Imports*
import Settings from "../components/Settings";

const StartScreen = () => {
  return (
    <>
      <Settings />
    </>
  );
};

export default StartScreen;
